import { z } from "zod/v4-mini";
import { Option } from "./option.js";
/**
 * Serializable structure that represents a group of options.
 */
export const OptionGroup = z.object({
    type: z.literal("option-group"),
    disabled: z.optional(z.boolean()),
    options: z.lazy(() => z.array(z.union([Option, OptionGroup]))),
    label: z.string(),
});
/**
 * Creates a new option group.
 * @param props Properties that define the option group.
 * @returns The option group.
 */
export function optionGroup(props) {
    const { disabled, options, label } = props;
    return {
        type: "option-group",
        disabled,
        label,
        options,
    };
}
